import AbstractDispatcher from 'frontools/abstract/AbstractDispatcher';
import Template from 'frontools/data/Template';
import { OverlayOptions, Overlay } from './Overlay';
import Breakpoint from 'frontools/core/Breakpoint';
import Context from 'frontools/core/Context';
import ImageLoader from './ImageLoader';

declare var Swiper;

export default class OverlaysManager extends AbstractDispatcher {


    public static  OVERLAY_SELECTOR  : string  = 'data-js-overlay-content';

    private _overlayButtons  : NodeListOf<HTMLElement>;

    public activeOverlay    : Overlay;
    private _maxWidth        : number;
    private _maxHeight       : number;
    private _ratio           : number;
    private _swiper         : Swiper;
    private _imageLoader     : ImageLoader;

    private _resizeElements     : Array<HTMLElement>    = [];

    constructor() {
        super();

        this._createOverlays(); 
    }

    private _createOverlays() {
        this._overlayButtons = document.querySelectorAll('['+OverlaysManager.OVERLAY_SELECTOR+']') as NodeListOf<HTMLElement>;
        for (let index = 0; index < this._overlayButtons.length; index++) { 
            this._overlayButtons[index].addEventListener('click', function() {
                this._createOverlay(this._overlayButtons[index]);
            }.bind(this))
        }
    }

    private _createOverlay(element:HTMLElement) {
        this._resizeElements = [];
        var template = (new Template(document.getElementById('overlay_slider_template'),{})).htmlAsDOM;
        var elementsString = element.getAttribute(OverlaysManager.OVERLAY_SELECTOR);
        if (elementsString) var elementsArray = JSON.parse(elementsString);
        if (elementsString && elementsArray.length > 1) {
            var swiperContainer = template.querySelector('.m_slider') as HTMLElement;
            var swiperWrapper = template.querySelector('.swiper-wrapper') as HTMLElement;
            for (let j = 0; j < elementsArray.length; j++) {
                let img = document.createElement('img');
                var slide = (new Template(document.getElementById('overlay_slide_template'),{
                    imageSource: elementsArray[j].imageUrl
                })).htmlAsDOM.firstElementChild;   
                swiperWrapper.appendChild(slide);
            }
        
            let options = new OverlayOptions();
            options.blackBackground = true; 
            options.customClasses = 'no_wrap';
            this.activeOverlay = new Overlay(swiperContainer, options); 
            // setTimeout(() => {
    
                let swiperIndex = element.getAttribute('data-js-overlay-index') ? element.getAttribute('data-js-overlay-index') : 0;
    
                this._swiper = new Swiper(swiperContainer, {   
                    // speed: 400,
                    setWrapperSize: true,
                    spaceBetween: 30,
                    slidesPerView: 1, 
                    nextButton: '.swiper-button-next',
                    prevButton: '.swiper-button-prev',
                    pagination: '.swiper-pagination',
                    centeredSlides: true,
                    initialSlide: swiperIndex,
                    onInit: (swiper) => {
                        let slides = (swiper as any).container[0].querySelectorAll('.swiper-slide');
                        this._imageLoader = new ImageLoader(slides);
                        TweenMax.set(swiper.container[0], {opacity:0});
                        this._imageLoader.addListener(ImageLoader.LOADED, () => {
                            for (var i = 0; i < slides.length; i++) {
                                this._resizeElements.push(slides[i] as HTMLElement);
                            }
                            this.onResize();
                            TweenMax.to(swiper.container[0], 0.4,{opacity:1});
                        })
                    },
                    paginationType: 'custom',
                    paginationCustomRender: function (swiper, current, total) {
                        return current + '/' + total;
                    }
                });
            // }, 1000);
        } else {
            var content = element.querySelector('img');
            var img = document.createElement('img');
            var div = document.createElement('div');
            img.src = content.src;
            div.setAttribute('data-image-resize', ""+img.height/img.width);
            div.appendChild(img);

            let options = new OverlayOptions();
            options.blackBackground = true; 
            options.customClasses = 'no_wrap one_image';
            this.activeOverlay = new Overlay(div, options);    
            this._resizeElements.push(div);
        }

        if (this.activeOverlay) this.activeOverlay.addListener(Overlay.CLOSE, () => {
            this._resizeElements = [];
            this.activeOverlay = undefined;
            this._swiper = undefined;
        })
        
        this.onResize();
    }

    /**  
     * onResize - Resize handler
     * 
     */
    public onResize() {
        if (!this._resizeElements.length) return;
        this._maxWidth = Math.round((Context.getInstance().viewport.width));
        this._maxHeight = (Math.round(Context.getInstance().viewport.height));

        this.resizeImages();    
    }   

    public resizeImages() {
        for (var i = 0; i < this._resizeElements.length; i++) {
            let ratio = Number(this._resizeElements[i].getAttribute('data-image-resize'));
    
            let height = this._maxHeight,
                width = Math.round(this._maxHeight / ratio);
    
            if (width > this._maxWidth) {
                width = this._maxWidth;
                height = this._maxWidth * ratio;
            }
            
            this._resizeElements[i].style.height = `${height}px`;
            this._resizeElements[i].style.width = `${width}px`;
            
        }

        if (this._swiper) {
            this._swiper.onResize();
        }

    }


}